<script setup>
import { onMounted, ref } from 'vue';
import Icon from '@/components/Icon.vue';
import { formatNumber } from '@/libs/functions';
import api from '@/libs/api.js';
import EventBus from "@/libs/eventBus";
import ModalShow from "@/components/ModalShow.vue";
import PDF from "pdf-vue3";

const data = ref(null);
const file_path = ref({})
const BASE_URL = ref(process.env.VUE_APP_API_BASE_URL)
onMounted(() => {
    getData();



});

const getData = (status = false) => {
    api.get('app/home')
        .then((response) => {
            data.value = response.data.data;
            file_path.value = JSON.parse(data.value.file_path)

        }).catch((err) => {
            if (err?.response?.status === 404 && status) {
                EventBus.emit('show-notification', JSON.stringify({
                    id: '',
                    title: "Không tìm thấy hợp đồng bạn ơi!",
                    message: `Có vẻ như tài khoản và số điện thoại của bạn chưa đưuọc liên kết với bất kỳ hợp đồng nào trên hệ thống. Hãy liên hệ lại với đơn vị quản lý của bạn để được hỗ trợ nhé.`,
                    url: '',
                    type: 'danger-popup',
                    showtime: 2000
                }));
            }
        });
};
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};
const showContract = ref(false)
const handleShowContract = () => {
    showContract.value = true
}
const close = () => {
    showContract.value = false
}
</script>
<template>
    <div class="w-full h-full relative overflow-auto pb-20">
        <div class="w-full fixed top-0 left-0 bg-white z-10 h-14 flex justify-start items-center px-6 shadow">
            <h1 class="first-letter:uppercase text-2xl text-gray-800 font-semibold w-full"
                :class="{ 'text-lg': false }">
                Hợp đồng
            </h1>
            <div v-if="data" class="flex-none w-auto">
                <div
                    class="w-auto rounded-full border border-white text-main px-3 py-1.5 text-xs font-medium bg-slate-200">
                    {{ data.identifier }}
                </div>
            </div>
        </div>
        <template v-if="data">
            <div class="w-full h-auto">
                <div class="w-full px-6 pt-6">
                    <div class="w-full flex justify-between items-center">
                        <h2 class="font-medium text-lg text-gray-600">Địa chỉ</h2>
                        <div class="flex justify-end items-center gap-1" @click="handleShowContract">
                            <p class="text-main">Xem điều khoản</p>
                            <Icon name="arrow-right" class="w-5 h-5 fill-gray-800" />
                        </div>
                    </div>
                    <div class="w-full h-auto bg-white rounded-md shadow-sm border mt-4 p-4">
                        <div class="w-full grid grid-cols-2">
                            <p>Tòa nhà:</p>
                            <p class="font-medium text-right">{{ data.project?.name }}</p>
                        </div>
                        <div class="w-full grid grid-cols-2">
                            <p>Phòng:</p>
                            <p class="font-medium text-right">
                                {{ data.room?.name }}
                            </p>
                        </div>
                        <div class="w-full grid grid-cols-2">
                            <p>Địa chỉ chi tiết:</p>
                            <p class="font-medium text-right">
                                {{
                                    `${data.project?.address}, ${data.project?.district?.name}, ${data.project?.city?.name}`
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="w-full px-6 pt-6">
                    <div class="w-full flex justify-between items-center">
                        <h2 class="font-medium text-lg text-gray-600">Thời gian thuê</h2>
                    </div>
                    <div class="w-full h-auto bg-white rounded-md shadow-sm border mt-4 p-4 divide-y">
                        <div class="w-full">
                            <div class="flex">
                                <div class="w-full border-l-2 border-indigo-200 pl-2">
                                    <p class="font-medium text-indigo-600">Ngày bắt đầu</p>
                                    <p class="text-sm">{{ formatDate(data.start_date) }}</p>
                                </div>
                                <div class="w-full border-l-2 border-red-300 pl-2">
                                    <p class="font-medium text-red-500">Ngày kết thúc</p>
                                    <p class="text-sm">{{ formatDate(data.expire_date) }}</p>
                                </div>
                            </div>

                            <p class="w-full py-4 text-gray-800">
                                <span class="font-medium">Số ngày còn lại:</span> {{ data.dayRemaining }}
                            </p>
                        </div>
                        <div class="w-full flex justify-between pt-4">
                            <div class="w-max">
                                <p class="font-medium text-gray-400">Tòa nhà</p>
                                <p class="text-sm font-medium">{{ data.project?.name }}</p>
                            </div>
                            <div class="w-max flex flex-col items-end">
                                <p class="font-medium text-gray-400">Phòng</p>
                                <p class="text-sm font-medium">{{ data.room?.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full px-6 pt-6">
                    <div class="w-full flex justify-between items-center">
                        <h2 class="font-medium text-lg text-gray-600">Tiền thuê và các khoản phí (VND)</h2>
                    </div>
                    <div class="w-full h-auto bg-white rounded-md shadow-md border mt-4 divide-y">
                        <div class="w-full grid grid-cols-2 p-4">
                            <div>
                                <p>Tiền nhà</p>
                                <p class="text-xs text-gray-600">
                                    {{ data.payment_cycle < 12 ? 'Theo tháng' : 'Theo năm' }} </p>
                            </div>
                            <p class="text-right text-sm">
                                {{ formatNumber(data.rental_price) }} VND / <span class="text-xs">{{ (data.payment_cycle
                                    < 12 ? 'tháng' : 'năm') }}</span>
                            </p>
                        </div>
                        <div class="w-full grid grid-cols-2 p-4">
                            <div>
                                <p>Tiền cọc</p>
                            </div>
                            <p class="text-right text-sm">
                                {{ formatNumber(data.deposit_price) }} VND
                            </p>
                        </div>
                        <div class="w-full grid grid-cols-2 p-4" v-for="(item, k) in data.contract_fee" :key="k">
                            <div>
                                <p>{{item.service.name}}</p>
                                <p class="text-xs text-gray-600" v-if="item.meter">{{item.meter.name}}</p>
                                <p class="text-xs text-gray-600" v-else>Số lượng: {{item.quantity}}</p>
                            </div>
                            <p class="text-right">
                                {{ formatNumber(item.service.price) }} VND / {{item.service.unit}}
                            </p>
                        </div> 
                    </div>
                </div>
                <div class="w-full px-6 pt-6">
                    <div class="w-full flex justify-between items-center">
                        <h2 class="font-medium text-lg text-gray-600">Người thuê</h2>
                    </div>
                    <div class="w-full h-auto bg-white rounded-md shadow-sm border mt-4 p-4">
                        <div class="w-full grid grid-cols-2">
                            <p>Họ tên:</p>
                            <p class="font-medium text-right">
                                {{ data.tenant ? data.tenant.name : '' }}
                            </p>
                        </div>
                        <div class="w-full grid grid-cols-2">
                            <p>Số điện thoại:</p>
                            <p class="font-medium text-right">
                                {{ data.tenant ? data.tenant.phone : '' }}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </template>
        <template v-else>
            <div class="w-full px-6 text-justify">
                <img src="@/assets/images/search.webp" alt="image" class="w-4/5 h-auto mx-auto">
                <div class="flex flex-col gap-4 text-gray-500 py-4 text-sm">
                    <p class="text-lg text-gray-800 font-medium text-center">Bạn không có hợp đồng nào!</p>
                    <p>
                        Nếu đơn vị quản lý vận hành đang sử dụng mà bạn chưa thấy thông tin hợp đồng, vui lòng:
                    </p>
                    <p>
                        1. Kiểm tra với đơn vị quản lý về thông tin của bạn đã được khai báo hay chưa.
                    </p>
                    <p>
                        2. Kiểm tra số điện thoại của bạn đăng nhập có trùng với số điện thoại đợn vị quản lý khai báo
                        hay không.
                    </p>
                    <p>
                        3. Thử ấn vào nút bên dưới để hệ thống tìm kiếm liên kết hợp đồng.
                    </p>
                    <button @click="getData(true)"
                        class="bg-main rounded-md w-full py-3 text-white text-lg font-semibold shadow">
                        Tìm kiếm hợp đồng
                    </button>
                </div>
            </div>
        </template>
    </div>
    <ModalShow :show="showContract" title="Thông tin hợp đồng" @call-back="close">
        <div class="w-full h-full bg-white">
            <PDF :src="`${BASE_URL}${file_path.pdf_path}`" />
        </div>
    </ModalShow>
</template>
<style>
.javascript {
    max-width: 90px;
    max-height: 90px;
    top: 45px;
    left: 45px;
}

.javascript+svg .outer {
    stroke: #f0e040;
}

.node {
    width: 200px;
    height: 200px;
    top: 45px;
    left: 45px;
}

.node+svg .outer {
    stroke: #83cd29;
}

.chart svg {
    position: absolute;
    top: 0;
    left: 0;
}

.outer {
    fill: transparent;
    stroke: #333;
    stroke-width: 20;
    stroke-dasharray: 534;
    transition: stroke-dashoffset 1s;
    -webkit-animation-play-state: running;

    /* firefox bug fix - won't rotate at 90deg angles */
    -moz-transform: rotate(-89deg) translateX(-190px);
}

.chart:hover .outer {
    stroke-dashoffset: 534 !important;
    -webkit-animation-play-state: paused;
}

/* END Circle colors and graphic positions */


/* Set the initial values for the animation */
.chart[data-percent='100'] .outer {
    stroke-dashoffset: 0;
    -webkit-animation: show100 2s;
    animation: show100 2s;
}

.chart[data-percent='75'] .outer {
    stroke-dashoffset: 133;
    -webkit-animation: show75 2s;
    animation: show75 2s;
}

.chart[data-percent='50'] .outer {
    stroke-dashoffset: 267;
    -webkit-animation: show50 2s;
    animation: show50 2s;
}

.chart[data-percent='25'] .outer {
    stroke-dashoffset: 401;
    -webkit-animation: show25 2s;
    animation: show25 2s;
}

/* END set initial animation values */

/* Keyframes for the initial animation */
@-webkit-keyframes show100 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 0;
    }
}

@keyframes show100 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 0;
    }
}

@-webkit-keyframes show75 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 134;
    }
}

@keyframes show75 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 124;
    }
}

@-webkit-keyframes show50 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 267;
    }
}

@keyframes show50 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 267;
    }
}

@-webkit-keyframes show25 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 401;
    }
}

@keyframes show25 {
    from {
        stroke-dashoffset: 537;
    }

    to {
        stroke-dashoffset: 401;
    }
}
</style>
